var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Empty } from 'antd';
/**
 * 统一的"暂无数据"占位组件
 * 用于在组件 Panel 框架内显示空状态
 */
export var EmptyDataPlaceholder = function (_a) {
    var _b = _a.description, description = _b === void 0 ? '暂无数据' : _b, style = _a.style;
    return (_jsx("div", __assign({ style: __assign({ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }, style) }, { children: _jsx(Empty, { description: description, image: Empty.PRESENTED_IMAGE_SIMPLE, style: { margin: 0 } }) })));
};
